import { render, staticRenderFns } from "./ProfileActivity.vue?vue&type=template&id=e54ab6f2&scoped=true"
import script from "./ProfileActivity.vue?vue&type=script&lang=ts"
export * from "./ProfileActivity.vue?vue&type=script&lang=ts"
import style0 from "./ProfileActivity.vue?vue&type=style&index=0&id=e54ab6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54ab6f2",
  null
  
)

export default component.exports